module.exports = __webpack_public_path__ + "starwarslogo.b02209e44899632b6e62.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/starwarslogo.svg
// module id = 314
// module chunks = 2